import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DetectMfeRoot } from 'zignal-mfe-detectui/dist/zignal-mfe-detect-ui.es';
// import 'zignal-mfe-detectui/dist/style.css';
import './index.css';

const mapStateToProps = (
  (state) => ({
    // Flags
    fetchingDetectStreams: state.DetectSettings.fetchingDetectStreams,
    // DATA
    detectStreamsList: state.DetectSettings.detectStreamsList,
    campaign: state.DetectSettings.campaign,
    featureFlags: state.DetectSettings.featureFlags,
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const Detect = ({
  userId,
  detectStreamsList = [],
  featureFlags = [],
  fetchingDetectStreams = true,
  campaign = {}
}) => {
  return (
    <DetectMfeRoot
      initialRoute="/detect"
      streams={detectStreamsList}
      userId={userId}
      isStandalone={false}
      splitIoFeatures={featureFlags}
    />
  );
};

Detect.propTypes = {
  fetchingDetectStreams: PropTypes.bool,
  userId: PropTypes.string.isRequired,
  // data
  detectStreamsList: PropTypes.array,
  campaign: PropTypes.object,
  featureFlags: PropTypes.array,
};

export default connect(mapStateToProps, {}, mergeProps)(Detect);
